import {Component, OnInit, Input, EventEmitter, Output} from '@angular/core';
import {IInputACPreset, INPUT_AC_PRESET} from "./InputACPreset";
import {FormBuilder} from "@angular/forms";
import {ResetSpecsService} from "../../../reset-specs.service";
import {TranslateService} from "@ngx-translate/core";
import {setWindowTitle} from "../../../../commonUtil";

@Component({
  selector: 'edsng-acdc-preset',
  templateUrl: './preset.component.html',
  styleUrls: ['./preset.component.css']
})
export class PresetComponent  {
  @Input() acPreset: IInputACPreset[];
  @Output() onSelect = new EventEmitter();
  voltageModel: any = {text: "", lastValue: { name: '', fLineNom: ''}};

  constructor(public translate: TranslateService) {
    this.translate.onLangChange
      .subscribe(() => {
        this.voltageModel.text = `${this.translate.instant(`GRID.form.${this.voltageModel.lastValue.name}`)} - ${this.voltageModel.lastValue.fLineNom} ${this.translate.instant('GRID.form.hz')}`;
      });
  }


  selectedAcInput(val: IInputACPreset) {
    this.voltageModel.text = `${this.translate.instant(`GRID.form.${val.name}`)} - ${val.fLineNom} ${this.translate.instant('GRID.form.hz')}`;
    this.voltageModel.lastValue = { name: val.name, fLineNom: val.fLineNom};
    this.onSelect.emit(val);
  }

  setSelectedAC(vmin: number, vmax: number, freq: number) {
    const preset = this.acPreset.find(x => x.VinMin === vmin && x.VinMax === vmax && x.fLineNom === freq);
    if (preset !== undefined) {
      this.voltageModel.text = `${this.translate.instant(`GRID.form.${preset.name}`)} - ${preset.fLineNom} ${this.translate.instant('GRID.form.hz')}`;
      this.voltageModel.lastValue = { name: preset.name, fLineNom: preset.fLineNom};
    } else {
      this.voltageModel.text = 'Custom';
    }
  }
}
